// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { Program } from './program';
import { Supplier } from './supplier';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class ProgramSupplier extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  /** Guid key */
  id!: string;
  /** Boolean */
  allowInventory!: boolean;
  /** String(50) */
  carrierAccountName?: string;
  /** String(50) */
  carrierAccountNumber?: string;
  /** String(10) */
  carrierAccountPostalCode?: string;
  /** Boolean */
  doesAccountPayFreight!: boolean;
  /** Decimal */
  handlingChargePerOrderAmt!: number;
  /** Decimal */
  handlingChargePerShipmentAmt!: number;
  /** Guid FK inventoryProgram */
  inventoryProgramId?: string;
  /** Guid FK program */
  programId!: string;
  /** Binary */
  rowVersion!: any;
  /** Boolean */
  shouldChargeFreightOnFirstShipmentOnly!: boolean;
  /** Guid FK supplier */
  supplierId!: string;
  /** FK inventoryProgramId */
  inventoryProgram!: Program;
  /** FK programId */
  program!: Program;
  /** FK supplierId */
  supplier!: Supplier;
}

